import React from 'react'
import { withRouter } from "@contexts/RouterProvider";
import RouterOutlet from './RouterOutlet'

const Index = ({ classes, resources }) => {
  return <RouterOutlet resources={resources} classes={classes} />
}

Index.defaultProps = {
  resources: []
}

export default withRouter(Index);
